import "custom-event-polyfill";
import { submitForm } from "../../lib/helpers.js";

const UpdateCartForm = el => {
	const varSelectEls = [
		...el.querySelectorAll("._js__update-cart-form__var-select"),
	];
	const varRadioEls = [
		...el.querySelectorAll("._js__update-cart-form__var-radio"),
	]; // either a select dropdown, or radio, depending on the form context
	const textInputEls = [...el.querySelectorAll("input[type='text']")];
	const submitEl = el.querySelector("._js__update-cart-form__submit");
	const submitEls = [
		...el.querySelectorAll("._js__update-cart-form__submit"),
		...document.querySelectorAll(`button[form="${el.id}"]`),
	];
	const fixedSubmitWrapperEls = [
		...document.querySelectorAll("._js__pdp-purchase-form__fixed-submit-wrapper"),
	];
	const noteEls = [
		...el.querySelectorAll(
			"._js__update-cart-form__submit ._js__submit-button__note"
		),
		...document.querySelectorAll(
			`button[form="${el.id}"] ._js__submit-button__note`
		),
	];
	const priceEls = [
  	...document.querySelectorAll("._js__update-product-price"),
	];
	let parentForm;

	const recOptionsEl = el.querySelector("._js__update-cart-form__rec-options");
	const recOptions = [
		...el.querySelectorAll("._js__update-cart-form__rec-option"),
	];
	const recOptionRadios = [
		...el.querySelectorAll("._js__update-cart-form__rec-option-radio"),
	];

	const gcOptionsRadios = [
		...el.querySelectorAll("._js__update-cart-form__gc-option-radio"),
	];
	const gcCustomAmountEl = [
		...el.querySelectorAll("._js__update-cart-form__gc-custom-amount"),
	];
	const gcCustomAmountMeta = el.querySelector(
		"._js__update-cart-form__gc-custom-amount-meta"
	);
	const qtyAdjustInputs = [
	  ...el.querySelectorAll("._js__pdp-quantity-adjust__input")
  ];
  
  const qtyInputUpdated = qtyInputUpdated => {
    var input = event.target;
    var productCheckbox = document.getElementById(input.dataset.checkbox);
    
    updatePriceNote(productCheckbox.dataset.productIndex, parseFloat(productCheckbox.dataset.price * input.value));

    
    if (input.value > input.min) {
      input.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = false;
    } else {
      input.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = true;
    }
    
    if (input.value < input.max) {
      input.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="1"]').disabled = false;
    } else {
      input.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="1"]').disabled = true;
    }
    
    if (input.value > 0) {
      productCheckbox.checked = true;
    } else {
      productCheckbox.checked = false;
    }
  }
  
  qtyAdjustInputs.forEach(el => {
    el.addEventListener("change", qtyInputUpdated)
  });

  const updateItemCount = lineItemCount => {
		const cartItemCountEls = [
			...document.querySelectorAll("._js__cart-item-count"),
		];
		cartItemCountEls.forEach(el => {
			el.classList.add("cart-item-count--ready");
			el.innerHTML = lineItemCount;
		});
	};
	
	const accOptionsCheckboxes = [
  	...el.querySelectorAll("._js__update-cart-form__accessory-option-checkbox"),
	]
	
	const qtyButtons = [
	  ...el.querySelectorAll("._js__pdp-quantity-adjust")
  ]
	
	const justAddedPopupDismiss = [
  	...document.querySelectorAll(".__js-close-popup-cart"),
	];
	
	const fadeOutPopupCart = popupCart => {
    var popupCart = document.querySelector("#pop-up-cart");
    
    if (popupCart.style.display == "block") {
  	  var op = 1;
      var timer = setInterval(function() {
        if (op <= 0.1) {
          clearInterval(timer);
          popupCart.style.display = "none";
          document.documentElement.style.overflow = "visible";
          document.body.style.overflow = "visible";
        }
        popupCart.style.opacity = op;
        popupCart.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op -= op * 0.1;
      }, 10);
    }
	};
	
	justAddedPopupDismiss.forEach(el => {
  	el.addEventListener("click", fadeOutPopupCart)
	});
	
	const updatePDPQty = pdpQty => {
  	var button = event.target;
    var input = document.getElementById(button.dataset.input);
    var newQty = parseInt(input.value) + parseInt(button.dataset.amendment);
    var productCheckbox = document.getElementById(button.dataset.checkbox);

    if (newQty >= input.min && newQty <= input.max) {
      input.value = newQty;
      
      updatePriceNote(productCheckbox.dataset.productIndex, parseFloat(productCheckbox.dataset.price * newQty));
    }
    
    if (newQty > 0) {
      productCheckbox.checked = true;
    } else {
      productCheckbox.checked = false;
    }
    
    if ((button.dataset.amendment == "1" && newQty == input.max) || (button.dataset.amendment == "-1" && newQty == input.min)) {
      button.disabled = true;
    }
    
    if (button.dataset.amendment == "1" && newQty > input.min) {
      button.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = false;
    } else if (button.dataset.amendment == "1") {
      button.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = true;
    }
    
    if (button.dataset.amendment == "-1" && newQty < input.max) {
      button.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="1"]').disabled = false;
    } else if (button.dataset.amendment == "-1") {
      button.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="1"]').disabled = true;
    }
	};

	qtyButtons.forEach(el => {
  	el.addEventListener("click", updatePDPQty)
	});
	
	const updateAccQty = accInput => {
  	var accInput = event.target;
  	if (accInput.dataset.qtyInputId) {
  	  var qtyInput = document.getElementById(accInput.dataset.qtyInputId);
      if (accInput.checked && qtyInput.value == 0) {
    	  qtyInput.value = 1;
    	  qtyInput.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = false;
  	  }
      if (!accInput.checked) {
    	  qtyInput.value = qtyInput.min;
    	  qtyInput.parentNode.querySelector('._js__pdp-quantity-adjust[data-amendment="-1"]').disabled = true;
      }
  	}
	}
	
	accOptionsCheckboxes.forEach(el => {
  	el.addEventListener("change", updateAccQty)
	})
	
	const justAddedPopup = itemsAdded => {
  	if (!window.matchMedia("only screen and (max-width: 760px)").matches) {
  	  var itemsAdded = parentForm.querySelectorAll("._js__update-cart-form__var-radio:checked, ._js__update-cart-form__rec-option-radio:checked, ._js__update-cart-form__accessory-option-checkbox:checked, ._js__update-cart-form__var-option:checked");
      var popupCartContents = document.querySelector("#pop-up-cart-contents");
      popupCartContents.innerHTML = "";
      var popUpCartContentsHtml = "";
      
      for (let i = 0; i < itemsAdded.length; i++) {
    	  if (itemsAdded[i].dataset.price != "0") {
    	    popUpCartContentsHtml += "<div class='border-b border-palemintgreen flex items-center py-5'>"
    	      popUpCartContentsHtml += "<img class='block w-18' src='" + itemsAdded[i].dataset.popupImg + "' srcset='" + itemsAdded[i].dataset.popupImgs + "' sizes='72px' alt='" + itemsAdded[i].dataset.productName + " - " + itemsAdded[i].dataset.variantName + "' loading='lazy' crossorigin='' width='72' height='90'>";
            popUpCartContentsHtml += "<div class='text-sm leading-relaxed pl-4'>";
              popUpCartContentsHtml += "<div class='font-bold'>" + itemsAdded[i].dataset.productName + "</div>";
              popUpCartContentsHtml += "<div>" + itemsAdded[i].dataset.variantName + "</div>";
              popUpCartContentsHtml += "<div class='font-bold'>£" + parseFloat(itemsAdded[i].dataset.price).toFixed(2) + "</div>";
            popUpCartContentsHtml += "</div>";
          popUpCartContentsHtml += "</div>";
    	  }
  	  }
      popupCartContents.innerHTML = popUpCartContentsHtml;
      
      var popupCart = document.querySelector("#pop-up-cart");
      
      popupCart.style.display = "block";
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      var op = 0.1;
      var timer = setInterval(function() {
        if (op >= 1) {
          clearInterval(timer);
          setTimeout(function() { fadeOutPopupCart() }, 3000);
        }
        popupCart.style.opacity = op;
        popupCart.style.filter = 'alpha(opacity=' + op * 100 + ")";
        op += op * 0.1;
      }, 10);
    }
  };

	const purchasablePrices = [parseFloat(el.dataset.defaultPrice)];

	const cartUpdatedEvent = new Event("cartupdated");
	const cartUpdatingEvent = new Event("cartupdating");
	const cartUpdateFailEvent = new Event("cartupdatefail");
	const loadStartEvent = new Event("loadstart");
	const loadEndEvent = new Event("loadend");
	const sizeSelectedEvent = new Event("sizeselected");

	let timeout;
	let disabled;

	const onUpdated = json => {
		console.log(`Cart updated:`, json);
		window.dispatchEvent(loadEndEvent);
		if (json.error) return onFail(json.error);
		submitEls.forEach(el => {
  		el.dataset.status = "success";
      timeout = setTimeout(() => {
				el.dataset.status = "default";
			 }, 2222);
		});
		updateItemCount(json.cart.totalQty);
		if (!document.querySelector("._js__cart-items")) {
  		justAddedPopup();
		}
		window.dispatchEvent(cartUpdatedEvent);
	};

	// For 'soft' errors, when the API works but can't update.
	const onFail = error => {
		window.dispatchEvent(loadEndEvent);
		window.dispatchEvent(cartUpdateFailEvent);
		submitEls.forEach(el => {
  		if (el.id != "submit-discount-code") {
			  el.dataset.status = "fail";
        timeout = setTimeout(() => {
				  el.dataset.status = "default";
			  }, 2222);
		  } else {
  		  el.closest("#discount-code-form").classList.add("discount-code-error");
  		  document.querySelector("#discount-code-error-message").classList.remove("hidden");
  		  document.querySelector("#discount-code-error-message").classList.add("flex");
		  }
		});
		textInputEls.forEach(el => (el.value = ""));
		console.warn(error);
	};

	// For 'hard' errors, when the API doesn't work.
	const onError = error => {
		window.dispatchEvent(loadEndEvent);
		window.dispatchEvent(cartUpdateFailEvent);
		submitEls.forEach(el => {
			el.dataset.status = "error";
			timeout = setTimeout(() => {
				el.dataset.status = "default";
			}, 2222);
		});
		textInputEls.forEach(el => (el.value = ""));
		console.error(error);
	};
	const onSubmit = e => {
		console.log("submit", e.target);
		e.preventDefault();
		parentForm = e.target;
		
		clearTimeout(timeout);
		if (!disabled) {
			submitEls.forEach(el => (el.dataset.status = "pending"));
			window.dispatchEvent(loadStartEvent);
			window.dispatchEvent(cartUpdatingEvent);

			const formData = new FormData(el);
			if (el.dataset.mode === "add") {
				if (window.fbq) window.fbq("track", "AddToCart"); // window.fbq will only be available when the user has accepted marketing cookies
				// if (gtag) {
				// 	gtag("event", "add_to_cart", {
				// 		value: 998.55,
				// 		items: [
				// 			{
				// 				id: el.dataset.id,
				// 				name: el.dataset.title,
				// 				google_business_vertical: "retail",
				// 			},
				// 		],
				// 	});
				// }
				// var dataLayer = window.dataLayer || [];
				// dataLayer.push({ecommerce: null});
				// dataLayer.push({
				// 	'event': 'addToCart',
				// 	'ecommerce': {
				// 		'currencyCode': 'GBP',
				// 		'value': el.getAttribute('data-default-price'),
				// 		'add': {
				// 			'products': [
				// 				{
				// 					'sku': el.dataset.sku,
				// 					'name': el.dataset.title,
				// 					'category': el.getAttribute('data-product-type'),
				// 					'price': el.getAttribute('data-default-price'),
				// 					'quantity': 1
				// 				}
				// 			]
				// 		}
				// 	}
				// });
				// window.dataLayer = dataLayer;
			}

			try {
				submitForm(formData)
					.then(onUpdated)
					.catch(onError);
			} catch (error) {
				onError(error);
			}
		}
	};

	const updatePriceNote = (purchasableIndex, price) => {
		purchasablePrices[purchasableIndex] = price;

		const subtotal = purchasablePrices.reduce(
			(acc, itemPrice) => (acc += itemPrice),
			0
		);
		
		const formatter = new Intl.NumberFormat("en-GB", {
			style: "currency",
			currency: "GBP",
			minimumFractionDigits: (Number.isInteger(subtotal) ? 0 : 2),
		});
		const formatted = formatter.format(subtotal);
		noteEls.forEach(el => (el.innerHTML = `${formatted} — `));
	};

	const onVarSelectChange = ({ currentTarget }) => {
		if (currentTarget.tagName.toLowerCase() === "select" && !currentTarget.value)
			return; // don't change reccommendations if the user goes back to select the 'please select variant' option
		if (currentTarget.tagName.toLowerCase() === "input" && !currentTarget.checked)
			return;
		if (currentTarget.selectedOptions && currentTarget.selectedOptions[0]) {
			updatePriceNote(
				0,
				parseFloat(currentTarget.selectedOptions[0].dataset.price)
			);
		} else {
			updatePriceNote(0, parseFloat(currentTarget.dataset.price));
		}

		submitEls.forEach(el => (el.disabled = false));
		fixedSubmitWrapperEls.forEach(el =>
			el.classList.remove("pdp-purchase-form__fixed-submit-wrapper--is-hidden")
		);
		if (recOptionsEl) {
			recOptionsEl.classList.remove("pdp-purchase-form__rec-options--disabled");
			recOptionsEl.classList.remove("pdp-sticky-header__fieldset--disabled");
		}

		// When updating the variant select, auto-select the default pot (none)
		recOptions.forEach(el => {
			el.selected = false;
			if (!el.dataset.recommendedBy) {
				el.style.display = "block";
				if (el.htmlFor) {
				  var inputEl = document.querySelector("#" + el.htmlFor);
				} else {
  				var inputEl = el.querySelector("input");
				}
				inputEl.checked = true;
				const event = new Event("change");
				inputEl.dispatchEvent(event);
				return;
			}
			// ...and show / hide the reccomendations for this variant.
			if (
				el.dataset.recommendedBy === currentTarget.value ||
				el.dataset.recommendedBy === "all"
			) {
  			if (el.parentNode.classList.contains("custom-radio-input")) {
				  el.parentNode.parentNode.parentNode.style.display = "block";
          el.parentNode.parentNode.parentNode.classList.remove("displayNone");
        } else {
          el.style.display = "block";
        }
			} else {
  			if (el.parentNode.classList.contains("custom-radio-input")) {
				  el.parentNode.parentNode.parentNode.style.display = "none";
          el.parentNode.parentNode.parentNode.classList.add("displayNone");

          if (el.dataset.uncheck) {
  				  el.previousElementSibling.checked = false;
            updatePriceNote(1, parseFloat(0));
          }
				} else {
  				el.style.display = "none";
				}
			}
		});
		window.dispatchEvent(sizeSelectedEvent);
	};

	const onSizeRadioChange = ({ currentTarget }) => {
		updatePriceNote(
				0,
				parseFloat(currentTarget.dataset.price)
			);
		const formatter = new Intl.NumberFormat("en-GB", {
			style: "currency",
			currency: "GBP",
			minimumFractionDigits: (currentTarget.dataset.price.includes(".") ? 2 : 0),
		});
		const formatted = formatter.format(currentTarget.dataset.price);
		priceEls.forEach(el => (el.innerHTML = `${formatted}`));

		// When updating the variant select, auto-select the default pot (none)
		recOptions.forEach(el => {
			el.selected = false;
			if (!el.dataset.recommendedBy) {
				el.style.display = "block";
				const inputEl = document.querySelector("#" + el.htmlFor);
				inputEl.checked = true;
				const event = new Event("change");
				inputEl.dispatchEvent(event);
				return;
			}
			// ...and show / hide the reccomendations for this variant.
			if (
				el.dataset.recommendedBy === currentTarget.value ||
				el.dataset.recommendedBy === "all"
			) {
				el.parentNode.parentNode.parentNode.style.display = "block";
				el.parentNode.parentNode.parentNode.classList.remove("displayNone");
			} else {
				el.parentNode.parentNode.parentNode.style.display = "none";
				el.parentNode.parentNode.parentNode.classList.add("displayNone");

        if (el.dataset.uncheck) {
  				el.previousElementSibling.checked = false;
  				updatePriceNote(1, parseFloat(0));
				}
			}
		});
		window.dispatchEvent(sizeSelectedEvent);
	};

	const onRecSelectChange = ({ currentTarget }) => {
  	if (currentTarget.checked) {
		  updatePriceNote(1, parseFloat(currentTarget.dataset.price));
		} else {
  		updatePriceNote(1, parseFloat(0));
		}
		const event = new CustomEvent("carouselshowimage", {
			detail: {
				products: currentTarget.dataset.productId
					? currentTarget.dataset.productId.split(",")
					: null,
			},
		});
		window.dispatchEvent(event);
	};

	varSelectEls.forEach(el => {
		onVarSelectChange({ currentTarget: el }); // on load we want to check if there's one autoselected via query param
		el.addEventListener("change", onVarSelectChange);
	});
	varRadioEls.forEach(el => {
  	el.addEventListener("change", onSizeRadioChange)
	});
	recOptionRadios.forEach(el =>
		el.addEventListener("change", onRecSelectChange)
	);
	recOptions.forEach(el =>
		el.addEventListener("keydown", e => {
			if (e.which === 32 || e.which === 13) {
				e.currentTarget.querySelector("input").checked = true;
			}
		})
	);
	
	accOptionsCheckboxes.forEach(el =>
	  el.addEventListener("change", ({ currentTarget }) => {
  	  if (currentTarget.checked) {
    	  updatePriceNote(currentTarget.dataset.productIndex, parseFloat(currentTarget.dataset.price));
  	  } else {
    	  updatePriceNote(currentTarget.dataset.productIndex, parseFloat(0));
  	  }
	  })
	);

	gcOptionsRadios.forEach(el =>
		el.addEventListener("change", ({ currentTarget }) => {
			updatePriceNote(1, parseFloat(currentTarget.dataset.price));
			gcCustomAmountEl.forEach(el => {
				el.style.color = "#80b7b9";
				el.querySelector("input").value = "";
				el.querySelector(
					"._js__pdp-purchase-form__gc-custom-amount__note"
				).style.display = "none";
			});
			gcCustomAmountMeta.setAttribute("disabled", "");
			submitEl.removeAttribute("disabled");
			disabled = false;
		})
	);

	gcOptionsRadios.forEach(el =>
		el.addEventListener("keydown", e => {
			if (e.which === 32 || e.which === 13) {
				gcCustomAmountEl.forEach(el => {
					el.querySelector("input").value = "";
					el.style.color = "#80b7b9";
					el.querySelector(
						"._js__pdp-purchase-form__gc-custom-amount__note"
					).style.display = "none";
				});
				gcCustomAmountMeta.setAttribute("disabled", "");
				submitEl.removeAttribute("disabled");
				disabled = false;
			}
		})
	);

	gcCustomAmountEl.forEach(el => {
		const inputEl = el.querySelector("input");
		const noteEl = el.querySelector(
			"._js__pdp-purchase-form__gc-custom-amount__note"
		);
		inputEl.addEventListener("input", ({ currentTarget }) => {
			if (inputEl.value) {
				el.style.color = "#006f74";
				updatePriceNote(1, parseFloat(currentTarget.value));
				gcOptionsRadios.forEach(el => (el.checked = false));
				if (parseInt(inputEl.value) >= 10) {
					noteEl.style.display = "none";
					submitEl.removeAttribute("disabled");
					gcCustomAmountMeta.removeAttribute("disabled");
					disabled = false;
				}
				if (parseInt(inputEl.value) < 10) {
					noteEl.style.display = "block";
					submitEl.setAttribute("disabled", "");
					disabled = true;
				}
			} else {
				submitEl.setAttribute("disabled", "");
				noteEl.style.display = "none";
				el.style.color = "#80b7b9";
			}
		});
	});

	el.addEventListener("submit", onSubmit);
};

export default UpdateCartForm;
